module.exports = __webpack_public_path__ + "static/media/logoorange.d2f2461d.png";